export default "__VITE_ASSET__VeLaWzgU__"